import { IGetNewYorkST124Response } from "../entities-generated/models/project/get-new-york-st-124-response";
import { IProjectListing } from "../entities-generated/models/project/project-listing";
import { IProjectOverviewModel } from "../entities-generated/models/project/project-overview-model";
import { ApiClient } from "./admin-api-client";

class ProjectApiClientClass {
  public getActiveProjectList() {
    return ApiClient.get<IProjectListing[]>('projects/active');
  }

  public getInactiveProjectList() {
    return ApiClient.get<IProjectListing[]>('projects/inactive');
  }

  public getProjectOverview(projectId: string) {
    return ApiClient.get<IProjectOverviewModel>(`projects/${projectId.replace('.', '-')}/overview`);
  }

  public getNewYorkSt124(projectId: string) {
    return ApiClient.get<IGetNewYorkST124Response>(`projects/${projectId.replace('.', '-')}/ny-st124`);
  }
}

export const ProjectApiClient = new ProjectApiClientClass();